export default __webpack_public_path__ + "584e3e38861e3e7b193140f455f20933.svg";